// // // File: src/pages/HomePage.jsx
// import React, { useEffect, useRef } from "react";
// import "./HomePagePattern.css";

// function HomePagePattern() {
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     const useRandomColors = true; // ← Change to false to use CSS-defined colors
//     const randomSeed = Math.random() * 1000.0;

//     const canvas = canvasRef.current;
//     const gl = canvas.getContext('webgl');
//     if (!gl) {
//       alert('WebGL not supported');
//       return;
//     }

//     let width = canvas.parentElement.offsetWidth;
//     let height = canvas.parentElement.offsetHeight;
//     canvas.width = width;
//     canvas.height = height;
//     gl.viewport(0, 0, width, height);

//     const vertexShaderSource = `
//       attribute vec2 a_position;
//       varying vec2 v_uv;
//       void main() {
//         v_uv = (a_position + 1.0) * 0.5;
//         gl_Position = vec4(a_position, 0, 1);
//       }
//     `;

//     const fragmentShaderSource = `
//       precision highp float;
//       varying vec2 v_uv;
//       uniform float u_time;
//       uniform float u_seed;
//       uniform vec2 u_resolution;
//       uniform vec2 u_mouse;
//       uniform vec3 u_primary;
//       uniform vec3 u_secondary;

//       vec4 permute(vec4 x) {
//         return mod(((x*34.0)+1.0)*x, 289.0);
//       }

//       float snoise(vec3 v) {
//         const vec2  C = vec2(1.0/6.0, 1.0/3.0);
//         const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

//         vec3 i  = floor(v + dot(v, C.yyy));
//         vec3 x0 = v - i + dot(i, C.xxx);

//         vec3 g = step(x0.yzx, x0.xyz);
//         vec3 l = 1.0 - g;
//         vec3 i1 = min(g.xyz, l.zxy);
//         vec3 i2 = max(g.xyz, l.zxy);

//         vec3 x1 = x0 - i1 + C.xxx;
//         vec3 x2 = x0 - i2 + C.yyy;
//         vec3 x3 = x0 - D.yyy;

//         i = mod(i, 289.0);
//         vec4 p = permute(permute(permute(
//                   i.z + vec4(0.0, i1.z, i2.z, 1.0))
//                 + i.y + vec4(0.0, i1.y, i2.y, 1.0))
//                 + i.x + vec4(0.0, i1.x, i2.x, 1.0));

//         float n_ = 1.0/7.0;
//         vec3 ns = n_ * D.wyz - D.xzx;

//         vec4 j = p - 49.0 * floor(p * ns.z * ns.z);

//         vec4 x_ = floor(j * ns.z);
//         vec4 y_ = floor(j - 7.0 * x_);

//         vec4 x = x_ * ns.x + ns.yyyy;
//         vec4 y = y_ * ns.x + ns.yyyy;
//         vec4 h = 1.0 - abs(x) - abs(y);

//         vec4 b0 = vec4(x.xy, y.xy);
//         vec4 b1 = vec4(x.zw, y.zw);

//         vec4 s0 = floor(b0)*2.0 + 1.0;
//         vec4 s1 = floor(b1)*2.0 + 1.0;
//         vec4 sh = -step(h, vec4(0.0));

//         vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy;
//         vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww;

//         vec3 p0 = vec3(a0.xy,h.x);
//         vec3 p1 = vec3(a0.zw,h.y);
//         vec3 p2 = vec3(a1.xy,h.z);
//         vec3 p3 = vec3(a1.zw,h.w);

//         vec4 norm = inversesqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2,p2), dot(p3,p3)));
//         p0 *= norm.x;
//         p1 *= norm.y;
//         p2 *= norm.z;
//         p3 *= norm.w;

//         vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
//         m = m * m;
//         return 42.0 * dot(m*m, vec4(dot(p0,x0), dot(p1,x1),
//                                     dot(p2,x2), dot(p3,x3)));
//       }

//       void main() {
//         vec2 uv = (v_uv - 0.5) * 2.0;
//         uv.x *= u_resolution.x / u_resolution.y;

//         vec2 mouseNorm = u_mouse / u_resolution;
//         float dist = length(v_uv - mouseNorm);
//         uv += normalize(uv) * dist * 0.6;

//         float scale = 0.35;
//         float n = snoise(vec3(uv * scale + u_seed, u_time * 0.05));

//         float bands = 10.0;
//         float band = floor((n + 1.0) / 2.0 * bands);

//         vec3 color = mod(band, 2.0) < 1.0 ? u_primary : u_secondary;
//         gl_FragColor = vec4(color, 1.0);
//       }
//     `;

//     function createShader(gl, type, source) {
//       const shader = gl.createShader(type);
//       gl.shaderSource(shader, source);
//       gl.compileShader(shader);
//       if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
//         console.error(gl.getShaderInfoLog(shader));
//         gl.deleteShader(shader);
//         return null;
//       }
//       return shader;
//     }

//     function createProgram(gl, vertexShader, fragmentShader) {
//       const program = gl.createProgram();
//       gl.attachShader(program, vertexShader);
//       gl.attachShader(program, fragmentShader);
//       gl.linkProgram(program);
//       if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
//         console.error(gl.getProgramInfoLog(program));
//         gl.deleteProgram(program);
//         return null;
//       }
//       return program;
//     }

//     const vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexShaderSource);
//     const fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, fragmentShaderSource);
//     const program = createProgram(gl, vertexShader, fragmentShader);

//     const positionBuffer = gl.createBuffer();
//     gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
//     gl.bufferData(
//       gl.ARRAY_BUFFER,
//       new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]),
//       gl.STATIC_DRAW
//     );

//     const positionLocation = gl.getAttribLocation(program, "a_position");
//     const timeLocation = gl.getUniformLocation(program, "u_time");
//     const resolutionLocation = gl.getUniformLocation(program, "u_resolution");
//     const mouseLocation = gl.getUniformLocation(program, "u_mouse");
//     const primaryLocation = gl.getUniformLocation(program, "u_primary");
//     const secondaryLocation = gl.getUniformLocation(program, "u_secondary");
//     const seedLocation = gl.getUniformLocation(program, "u_seed");

//     function cssColorToVec3(cssVar) {
//       const hex = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim().replace("#", "");
//       const bigint = parseInt(hex, 16);
//       return [
//         ((bigint >> 16) & 255) / 255,
//         ((bigint >> 8) & 255) / 255,
//         (bigint & 255) / 255,
//       ];
//     }

//     function randomColorVec3() {
//       return [Math.random(), Math.random(), Math.random()];
//     }

//     const primaryColor = useRandomColors ? randomColorVec3() : cssColorToVec3("--colourprimary");
//     const secondaryColor = useRandomColors ? randomColorVec3() : cssColorToVec3("--coloursecondary");

//     let mouse = [width / 2, height / 2];

//     function updateMouse(e) {
//       mouse = [
//         e.clientX ?? e.touches?.[0]?.clientX ?? width/2,
//         e.clientY ?? e.touches?.[0]?.clientY ?? height/2
//       ];
//     }

//     window.addEventListener("mousemove", updateMouse);
//     window.addEventListener("touchmove", updateMouse);

//     function render(timeMs) {
//       const time = timeMs * 0.001;

//       gl.viewport(0, 0, canvas.width, canvas.height);
//       gl.clearColor(0, 0, 0, 0);
//       gl.clear(gl.COLOR_BUFFER_BIT);

//       gl.useProgram(program);
//       gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
//       gl.enableVertexAttribArray(positionLocation);
//       gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);

//       gl.uniform1f(timeLocation, time);
//       gl.uniform1f(seedLocation, randomSeed);
//       gl.uniform2f(resolutionLocation, canvas.width, canvas.height);
//       gl.uniform2fv(mouseLocation, mouse);
//       gl.uniform3fv(primaryLocation, primaryColor);
//       gl.uniform3fv(secondaryLocation, secondaryColor);

//       gl.drawArrays(gl.TRIANGLES, 0, 6);

//       requestAnimationFrame(render);
//     }

//     requestAnimationFrame(render);

//     function handleResize() {
//       width = canvas.parentElement.offsetWidth;
//       height = canvas.parentElement.offsetHeight;
//       canvas.width = width;
//       canvas.height = height;
//       gl.viewport(0, 0, width, height);
//     }

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//       window.removeEventListener("mousemove", updateMouse);
//       window.removeEventListener("touchmove", updateMouse);
//     };
//   }, []);

//   return <canvas ref={canvasRef} className="pattern-canvas" />;
// }

// export default HomePagePattern;


////////////////////////////////////////////
// This code only uses "deliberate swiping" for the pattern movement so that its not glitchy when scrolling on touch. 
// it might be tooooo aggressive on the filtering for "deliberateness" this value might need tweaking
////////////////////////////////////////////
// import React, { useEffect, useRef } from "react";
// import "./HomePagePattern.css";

// function HomePagePattern() {
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     const useRandomColors = true;
//     const randomSeed = Math.random() * 1000.0;

//     const canvas = canvasRef.current;
//     const gl = canvas.getContext("webgl");
//     if (!gl) {
//       alert("WebGL not supported");
//       return;
//     }

//     let width = canvas.parentElement.offsetWidth;
//     let height = canvas.parentElement.offsetHeight;
//     canvas.width = width;
//     canvas.height = height;
//     gl.viewport(0, 0, width, height);

//     const vertexShaderSource = `
//       attribute vec2 a_position;
//       varying vec2 v_uv;
//       void main() {
//         v_uv = (a_position + 1.0) * 0.5;
//         gl_Position = vec4(a_position, 0, 1);
//       }
//     `;

//     const fragmentShaderSource = `
//       precision highp float;
//       varying vec2 v_uv;
//       uniform float u_time;
//       uniform float u_seed;
//       uniform vec2 u_resolution;
//       uniform vec2 u_mouse;
//       uniform vec3 u_primary;
//       uniform vec3 u_secondary;

//       vec4 permute(vec4 x) {
//         return mod(((x*34.0)+1.0)*x, 289.0);
//       }

//       float snoise(vec3 v) {
//         const vec2  C = vec2(1.0/6.0, 1.0/3.0);
//         const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

//         vec3 i  = floor(v + dot(v, C.yyy));
//         vec3 x0 = v - i + dot(i, C.xxx);

//         vec3 g = step(x0.yzx, x0.xyz);
//         vec3 l = 1.0 - g;
//         vec3 i1 = min(g.xyz, l.zxy);
//         vec3 i2 = max(g.xyz, l.zxy);

//         vec3 x1 = x0 - i1 + C.xxx;
//         vec3 x2 = x0 - i2 + C.yyy;
//         vec3 x3 = x0 - D.yyy;

//         i = mod(i, 289.0);
//         vec4 p = permute(permute(permute(
//                   i.z + vec4(0.0, i1.z, i2.z, 1.0))
//                 + i.y + vec4(0.0, i1.y, i2.y, 1.0))
//                 + i.x + vec4(0.0, i1.x, i2.x, 1.0));

//         float n_ = 1.0/7.0;
//         vec3 ns = n_ * D.wyz - D.xzx;

//         vec4 j = p - 49.0 * floor(p * ns.z * ns.z);
//         vec4 x_ = floor(j * ns.z);
//         vec4 y_ = floor(j - 7.0 * x_);

//         vec4 x = x_ * ns.x + ns.yyyy;
//         vec4 y = y_ * ns.x + ns.yyyy;
//         vec4 h = 1.0 - abs(x) - abs(y);

//         vec4 b0 = vec4(x.xy, y.xy);
//         vec4 b1 = vec4(x.zw, y.zw);
//         vec4 s0 = floor(b0)*2.0 + 1.0;
//         vec4 s1 = floor(b1)*2.0 + 1.0;
//         vec4 sh = -step(h, vec4(0.0));

//         vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy;
//         vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww;

//         vec3 p0 = vec3(a0.xy,h.x);
//         vec3 p1 = vec3(a0.zw,h.y);
//         vec3 p2 = vec3(a1.xy,h.z);
//         vec3 p3 = vec3(a1.zw,h.w);

//         vec4 norm = inversesqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2,p2), dot(p3,p3)));
//         p0 *= norm.x;
//         p1 *= norm.y;
//         p2 *= norm.z;
//         p3 *= norm.w;

//         vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
//         m = m * m;
//         return 42.0 * dot(m*m, vec4(dot(p0,x0), dot(p1,x1),
//                                     dot(p2,x2), dot(p3,x3)));
//       }

//       void main() {
//         vec2 uv = (v_uv - 0.5) * 2.0;
//         uv.x *= u_resolution.x / u_resolution.y;

//         vec2 mouseNorm = u_mouse / u_resolution;
//         mouseNorm.y = 1.0 - mouseNorm.y;
//         float dist = length(v_uv - mouseNorm);
//         float falloff = smoothstep(0.0, 0.5, dist);
//         uv += (uv * 0.3) * falloff;

//         float scale = 0.35;
//         float n = snoise(vec3(uv * scale + u_seed, u_time * 0.05));

//         float bands = 10.0;
//         float band = floor((n + 1.0) / 2.0 * bands);

//         vec3 color = mod(band, 2.0) < 1.0 ? u_primary : u_secondary;
//         gl_FragColor = vec4(color, 1.0);
//       }
//     `;

//     function createShader(gl, type, source) {
//       const shader = gl.createShader(type);
//       gl.shaderSource(shader, source);
//       gl.compileShader(shader);
//       if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
//         console.error(gl.getShaderInfoLog(shader));
//         gl.deleteShader(shader);
//         return null;
//       }
//       return shader;
//     }

//     function createProgram(gl, vertexShader, fragmentShader) {
//       const program = gl.createProgram();
//       gl.attachShader(program, vertexShader);
//       gl.attachShader(program, fragmentShader);
//       gl.linkProgram(program);
//       if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
//         console.error(gl.getProgramInfoLog(program));
//         gl.deleteProgram(program);
//         return null;
//       }
//       return program;
//     }

//     const vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexShaderSource);
//     const fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, fragmentShaderSource);
//     const program = createProgram(gl, vertexShader, fragmentShader);

//     const positionBuffer = gl.createBuffer();
//     gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
//     gl.bufferData(
//       gl.ARRAY_BUFFER,
//       new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]),
//       gl.STATIC_DRAW
//     );

//     const positionLocation = gl.getAttribLocation(program, "a_position");
//     const timeLocation = gl.getUniformLocation(program, "u_time");
//     const resolutionLocation = gl.getUniformLocation(program, "u_resolution");
//     const mouseLocation = gl.getUniformLocation(program, "u_mouse");
//     const primaryLocation = gl.getUniformLocation(program, "u_primary");
//     const secondaryLocation = gl.getUniformLocation(program, "u_secondary");
//     const seedLocation = gl.getUniformLocation(program, "u_seed");

//     function cssColorToVec3(cssVar) {
//       const hex = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim().replace("#", "");
//       const bigint = parseInt(hex, 16);
//       return [
//         ((bigint >> 16) & 255) / 255,
//         ((bigint >> 8) & 255) / 255,
//         (bigint & 255) / 255,
//       ];
//     }

//     function randomColorVec3() {
//       return [Math.random(), Math.random(), Math.random()];
//     }

//     const primaryColor = useRandomColors ? randomColorVec3() : cssColorToVec3("--colourprimary");
//     const secondaryColor = useRandomColors ? randomColorVec3() : cssColorToVec3("--coloursecondary");

//     let mouse = [width / 2, height / 2];
//     let touchStartX = 0;
//     let touchStartY = 0;
//     let isInteracting = false;
//     let isScrolling = false;
//     let interactionTimer = null;

//     function handleTouchStart(e) {
//       const touch = e.touches?.[0];
//       if (!touch || e.target !== canvas) return;

//       touchStartX = touch.clientX;
//       touchStartY = touch.clientY;
//       isInteracting = false;
//       isScrolling = false;

//       if (interactionTimer) clearTimeout(interactionTimer);
//       interactionTimer = setTimeout(() => {
//         if (!isScrolling) {
//           isInteracting = true;
//         }
//       }, 100); // Wait 100ms to decide
//     }

//     function handleTouchMove(e) {
//       const touch = e.touches?.[0];
//       if (!touch || e.target !== canvas) return;

//       const dx = touch.clientX - touchStartX;
//       const dy = touch.clientY - touchStartY;

//       if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) {
//         isScrolling = true;
//         isInteracting = false;
//         return; // let scroll proceed
//       }

//       if (isInteracting) {
//         mouse = [touch.clientX, touchStartY];
//       }
//     }

//     function updateMouse(e) {
//       mouse = [
//         e.clientX ?? width / 2,
//         e.clientY ?? height / 2
//       ];
//     }

//     function handleResize() {
//       width = canvas.parentElement.offsetWidth;
//       height = canvas.parentElement.offsetHeight;
//       canvas.width = width;
//       canvas.height = height;
//       gl.viewport(0, 0, width, height);
//     }

//     function render(timeMs) {
//       const time = timeMs * 0.001;

//       gl.viewport(0, 0, canvas.width, canvas.height);
//       gl.clearColor(0, 0, 0, 0);
//       gl.clear(gl.COLOR_BUFFER_BIT);

//       gl.useProgram(program);
//       gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
//       gl.enableVertexAttribArray(positionLocation);
//       gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);

//       gl.uniform1f(timeLocation, time);
//       gl.uniform1f(seedLocation, randomSeed);
//       gl.uniform2f(resolutionLocation, canvas.width, canvas.height);
//       gl.uniform2fv(mouseLocation, mouse);
//       gl.uniform3fv(primaryLocation, primaryColor);
//       gl.uniform3fv(secondaryLocation, secondaryColor);

//       gl.drawArrays(gl.TRIANGLES, 0, 6);
//       requestAnimationFrame(render);
//     }

//     requestAnimationFrame(render);

//     window.addEventListener("mousemove", updateMouse);
//     window.addEventListener("resize", handleResize);
//     canvas.addEventListener("touchstart", handleTouchStart, { passive: true });
//     canvas.addEventListener("touchmove", handleTouchMove, { passive: true });

//     return () => {
//       window.removeEventListener("mousemove", updateMouse);
//       window.removeEventListener("resize", handleResize);
//       canvas.removeEventListener("touchstart", handleTouchStart);
//       canvas.removeEventListener("touchmove", handleTouchMove);
//     };
//   }, []);

//   return <canvas ref={canvasRef} className="pattern-canvas" />;
// }

// export default HomePagePattern;


import React, { useEffect, useRef } from "react";
import "./HomePagePattern.css";

function HomePagePattern() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const useRandomColors = true;
    const randomSeed = Math.random() * 1000.0;

    const canvas = canvasRef.current;
    const gl = canvas.getContext("webgl");
    if (!gl) {
      alert("WebGL not supported");
      return;
    }

    let width = canvas.parentElement.offsetWidth;
    let height = canvas.parentElement.offsetHeight;
    canvas.width = width;
    canvas.height = height;
    gl.viewport(0, 0, width, height);

    const vertexShaderSource = `
      attribute vec2 a_position;
      varying vec2 v_uv;
      void main() {
        v_uv = (a_position + 1.0) * 0.5;
        gl_Position = vec4(a_position, 0, 1);
      }
    `;

    const fragmentShaderSource = `
      precision highp float;
      varying vec2 v_uv;
      uniform float u_time;
      uniform float u_seed;
      uniform vec2 u_resolution;
      uniform vec2 u_mouse;
      uniform vec3 u_primary;
      uniform vec3 u_secondary;

      vec4 permute(vec4 x) {
        return mod(((x*34.0)+1.0)*x, 289.0);
      }

      float snoise(vec3 v) {
        const vec2  C = vec2(1.0/6.0, 1.0/3.0);
        const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);

        vec3 i  = floor(v + dot(v, C.yyy));
        vec3 x0 = v - i + dot(i, C.xxx);

        vec3 g = step(x0.yzx, x0.xyz);
        vec3 l = 1.0 - g;
        vec3 i1 = min(g.xyz, l.zxy);
        vec3 i2 = max(g.xyz, l.zxy);

        vec3 x1 = x0 - i1 + C.xxx;
        vec3 x2 = x0 - i2 + C.yyy;
        vec3 x3 = x0 - D.yyy;

        i = mod(i, 289.0);
        vec4 p = permute(permute(permute(
                  i.z + vec4(0.0, i1.z, i2.z, 1.0))
                + i.y + vec4(0.0, i1.y, i2.y, 1.0))
                + i.x + vec4(0.0, i1.x, i2.x, 1.0));

        float n_ = 1.0/7.0;
        vec3 ns = n_ * D.wyz - D.xzx;

        vec4 j = p - 49.0 * floor(p * ns.z * ns.z);
        vec4 x_ = floor(j * ns.z);
        vec4 y_ = floor(j - 7.0 * x_);

        vec4 x = x_ * ns.x + ns.yyyy;
        vec4 y = y_ * ns.x + ns.yyyy;
        vec4 h = 1.0 - abs(x) - abs(y);

        vec4 b0 = vec4(x.xy, y.xy);
        vec4 b1 = vec4(x.zw, y.zw);
        vec4 s0 = floor(b0)*2.0 + 1.0;
        vec4 s1 = floor(b1)*2.0 + 1.0;
        vec4 sh = -step(h, vec4(0.0));

        vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy;
        vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww;

        vec3 p0 = vec3(a0.xy,h.x);
        vec3 p1 = vec3(a0.zw,h.y);
        vec3 p2 = vec3(a1.xy,h.z);
        vec3 p3 = vec3(a1.zw,h.w);

        vec4 norm = inversesqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2,p2), dot(p3,p3)));
        p0 *= norm.x;
        p1 *= norm.y;
        p2 *= norm.z;
        p3 *= norm.w;

        vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
        m = m * m;
        return 42.0 * dot(m*m, vec4(dot(p0,x0), dot(p1,x1),
                                    dot(p2,x2), dot(p3,x3)));
      }

      void main() {
        vec2 uv = (v_uv - 0.5) * 2.0;
        uv.x *= u_resolution.x / u_resolution.y;

        vec2 mouseNorm = u_mouse / u_resolution;
        mouseNorm.y = 1.0 - mouseNorm.y;
        float dist = length(v_uv - mouseNorm);
        float falloff = smoothstep(0.0, 0.5, dist);
        uv += (uv * 0.3) * falloff;

        float scale = 0.35;
        float n = snoise(vec3(uv * scale + u_seed, u_time * 0.05));

        float bands = 10.0;
        float band = floor((n + 1.0) / 2.0 * bands);

        vec3 color = mod(band, 2.0) < 1.0 ? u_primary : u_secondary;
        gl_FragColor = vec4(color, 1.0);
      }
    `;

    function createShader(gl, type, source) {
      const shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        console.error(gl.getShaderInfoLog(shader));
        gl.deleteShader(shader);
        return null;
      }
      return shader;
    }

    function createProgram(gl, vertexShader, fragmentShader) {
      const program = gl.createProgram();
      gl.attachShader(program, vertexShader);
      gl.attachShader(program, fragmentShader);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        console.error(gl.getProgramInfoLog(program));
        gl.deleteProgram(program);
        return null;
      }
      return program;
    }

    const vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexShaderSource);
    const fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, fragmentShaderSource);
    const program = createProgram(gl, vertexShader, fragmentShader);

    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(
      gl.ARRAY_BUFFER,
      new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]),
      gl.STATIC_DRAW
    );

    const positionLocation = gl.getAttribLocation(program, "a_position");
    const timeLocation = gl.getUniformLocation(program, "u_time");
    const resolutionLocation = gl.getUniformLocation(program, "u_resolution");
    const mouseLocation = gl.getUniformLocation(program, "u_mouse");
    const primaryLocation = gl.getUniformLocation(program, "u_primary");
    const secondaryLocation = gl.getUniformLocation(program, "u_secondary");
    const seedLocation = gl.getUniformLocation(program, "u_seed");

    function cssColorToVec3(cssVar) {
      const hex = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim().replace("#", "");
      const bigint = parseInt(hex, 16);
      return [
        ((bigint >> 16) & 255) / 255,
        ((bigint >> 8) & 255) / 255,
        (bigint & 255) / 255,
      ];
    }

    function randomColorVec3() {
      return [Math.random(), Math.random(), Math.random()];
    }

    const primaryColor = useRandomColors ? randomColorVec3() : cssColorToVec3("--colourprimary");
    const secondaryColor = useRandomColors ? randomColorVec3() : cssColorToVec3("--coloursecondary");

    let mouse = [width / 2, height / 2];

    function updateMouse(e) {
      mouse = [
        e.clientX ?? width / 2,
        e.clientY ?? height / 2
      ];
    }

    function handleTouch(e) {
      const touch = e.touches?.[0];
      if (!touch || e.target !== canvas) return;
      mouse = [touch.clientX, touch.clientY];
    }

    function handleResize() {
      width = canvas.parentElement.offsetWidth;
      height = canvas.parentElement.offsetHeight;
      canvas.width = width;
      canvas.height = height;
      gl.viewport(0, 0, width, height);
    }

    function render(timeMs) {
      const time = timeMs * 0.001;

      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);

      gl.useProgram(program);
      gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
      gl.enableVertexAttribArray(positionLocation);
      gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);

      gl.uniform1f(timeLocation, time);
      gl.uniform1f(seedLocation, randomSeed);
      gl.uniform2f(resolutionLocation, canvas.width, canvas.height);
      gl.uniform2fv(mouseLocation, mouse);
      gl.uniform3fv(primaryLocation, primaryColor);
      gl.uniform3fv(secondaryLocation, secondaryColor);

      gl.drawArrays(gl.TRIANGLES, 0, 6);
      requestAnimationFrame(render);
    }

    requestAnimationFrame(render);

    window.addEventListener("mousemove", updateMouse);
    window.addEventListener("resize", handleResize);
    canvas.addEventListener("touchstart", handleTouch, { passive: true });
    canvas.addEventListener("touchmove", handleTouch, { passive: true });

    return () => {
      window.removeEventListener("mousemove", updateMouse);
      window.removeEventListener("resize", handleResize);
      canvas.removeEventListener("touchstart", handleTouch);
      canvas.removeEventListener("touchmove", handleTouch);
    };
  }, []);

  return <canvas ref={canvasRef} className="pattern-canvas" />;
}

export default HomePagePattern;
